const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '')
const DEFAULT_LOCAL_API_URL = 'http://localhost:3000'

const normalizeBasePath = (value: string | undefined) => {
  if (!value || value === '/') {
    return '/'
  }

  const trimmedValue = value.trim()

  if (!trimmedValue) {
    return '/'
  }

  const withLeadingSlash = trimmedValue.startsWith('/')
    ? trimmedValue
    : `/${trimmedValue}`

  const normalizedValue = trimTrailingSlashes(withLeadingSlash)

  return normalizedValue || '/'
}

export interface TrackerAppEnv {
  apiBaseUrl: string
  basePath: string
  mapboxAccessToken: string
}

export const trackerAppEnv: TrackerAppEnv = {
  apiBaseUrl: import.meta.env.VITE_API_URL || DEFAULT_LOCAL_API_URL,
  basePath: normalizeBasePath(import.meta.env.VITE_BASE_PATH),
  mapboxAccessToken: import.meta.env.VITE_MAPBOX_ACCESS_TOKEN,
}

if (import.meta.env.DEV) {
  console.log('Order tracker API URL:', trackerAppEnv.apiBaseUrl)
}
